(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});



var $2Xzd1 = parcelRequire("2Xzd1");
var $756f64570420134b$var$STORAGE_KEY = 'relai_lang';
var $756f64570420134b$var$languagePopup = {
    selectedUrl: '',
    selectedLang: '',
    init: function() {
        var _this = this;
        var _this_popup_querySelector, _document_getElementById;
        this.popup = document.querySelector('.popup--language');
        if (!this.popup) return;
        this.selectedUrl = this.popup.getAttribute('data-selected-url') || '';
        this.selectedLang = this.popup.getAttribute('data-selected-lang') || '';
        this.popupContent = this.popup.querySelector('[data-popup-content]');
        this.langSelect = this.popup.querySelector('[data-language-select]');
        this.langToggle = this.popup.querySelector('[data-language-toggle]');
        this.langList = this.popup.querySelector('[data-language-list]');
        this.countrySelect = this.popup.querySelector('[data-country-select]');
        this.countryToggle = this.popup.querySelector('[data-country-toggle]');
        this.countryList = this.popup.querySelector('[data-country-list]');
        if (!this.langToggle || !this.langList) return;
        this.setupDropdown(this.langToggle, this.langList, this.langSelect, function(link) {
            return _this.onLanguageSelect(link);
        });
        if (this.countryToggle && this.countryList && this.countrySelect) this.setupDropdown(this.countryToggle, this.countryList, this.countrySelect, function(link) {
            return _this.onCountrySelect(link);
        });
        (_this_popup_querySelector = this.popup.querySelector('[data-popup-save]')) === null || _this_popup_querySelector === void 0 ? void 0 : _this_popup_querySelector.addEventListener('click', function() {
            return _this.save();
        });
        (_document_getElementById = document.getElementById('lang-switcher-btn')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.addEventListener('click', function() {
            return _this.open();
        });
        var pageLang = (window.location.pathname.split('/')[1] || '').toLowerCase();
        if (!localStorage.getItem($756f64570420134b$var$STORAGE_KEY) && pageLang.startsWith('de')) this.open();
    },
    open: function() {
        this.popup.classList.add('active');
    },
    save: function() {
        localStorage.setItem($756f64570420134b$var$STORAGE_KEY, this.selectedLang);
        if (this.selectedUrl) window.location.href = this.selectedUrl;
        else this.popup.classList.remove('active');
    },
    // Dropdown Functionality
    getLabel: function(toggle) {
        return toggle.querySelector('span:not(.popup__label):not(.popup__select-chevron)');
    },
    getVisibleItems: function(list) {
        return (0, $2Xzd1._)(list.querySelectorAll('.popup__select-link')).filter(function(el) {
            return !el.closest('[hidden]');
        });
    },
    openDropdown: function(toggle, list) {
        var _this;
        toggle.setAttribute('aria-expanded', 'true');
        var items = this.getVisibleItems(list);
        var active = list.querySelector('.popup__select-item--active:not([hidden]) .popup__select-link');
        (_this = active || items[0]) === null || _this === void 0 ? void 0 : _this.focus();
    },
    closeDropdown: function(toggle, returnFocus) {
        toggle.setAttribute('aria-expanded', 'false');
        if (returnFocus) toggle.focus();
    },
    setupDropdown: function(toggle, list, container, onSelect) {
        var _this = this;
        toggle.addEventListener('click', function() {
            toggle.getAttribute('aria-expanded') === 'true' ? _this.closeDropdown(toggle, true) : _this.openDropdown(toggle, list);
        });
        toggle.addEventListener('keydown', function(e) {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                _this.openDropdown(toggle, list);
            }
        });
        list.addEventListener('keydown', function(e) {
            var items = _this.getVisibleItems(list);
            var currentIndex = items.indexOf(document.activeElement);
            var keyActions = {
                'ArrowDown': function() {
                    e.preventDefault();
                    items[(currentIndex + 1) % items.length].focus();
                },
                'ArrowUp': function() {
                    e.preventDefault();
                    items[(currentIndex - 1 + items.length) % items.length].focus();
                },
                'Home': function() {
                    e.preventDefault();
                    items[0].focus();
                },
                'End': function() {
                    e.preventDefault();
                    items[items.length - 1].focus();
                },
                'Escape': function() {
                    e.preventDefault();
                    _this.closeDropdown(toggle, true);
                },
                'Tab': function() {
                    _this.closeDropdown(toggle, false);
                },
                'Enter': function() {
                    e.preventDefault();
                    if (currentIndex >= 0) onSelect(items[currentIndex]);
                },
                ' ': function() {
                    e.preventDefault();
                    if (currentIndex >= 0) onSelect(items[currentIndex]);
                }
            };
            var action = keyActions[e.key];
            if (action) action();
        });
        list.addEventListener('click', function(e) {
            var link = e.target.closest('.popup__select-link');
            if (link && !link.closest('[hidden]')) {
                e.preventDefault();
                onSelect(link);
            }
        });
        (this.popupContent || document).addEventListener('click', function(e) {
            if (toggle.getAttribute('aria-expanded') === 'true' && !container.contains(e.target)) _this.closeDropdown(toggle, false);
        });
    },
    // Country Selection
    showCountrySelect: function(languageBase) {
        if (!this.countrySelect) return;
        this.countrySelect.hidden = false;
        this.countryList.querySelectorAll('[data-base]').forEach(function(item) {
            item.hidden = item.getAttribute('data-base') !== languageBase;
        });
        var firstLink = this.countryList.querySelector('[data-base="'.concat(languageBase, '"]:not([hidden]) .popup__select-link'));
        if (firstLink) {
            var _firstLink_closest;
            this.syncToggleWithLink(this.countryToggle, firstLink);
            this.selectedUrl = firstLink.getAttribute('href') || ((_firstLink_closest = firstLink.closest('a')) === null || _firstLink_closest === void 0 ? void 0 : _firstLink_closest.href) || '';
            this.selectedLang = firstLink.getAttribute('lang') || languageBase;
        }
    },
    syncToggleWithLink: function(toggle, link) {
        var img = link.querySelector('img');
        var span = link.querySelector('span');
        var toggleImg = toggle.querySelector('img');
        var toggleLabel = this.getLabel(toggle);
        if (toggleImg && img) toggleImg.src = img.src;
        else if (!toggleImg && img) toggle.insertBefore(img.cloneNode(true), toggle.firstChild);
        if (toggleLabel && span) toggleLabel.textContent = span.textContent;
    },
    // Selection Handlers
    onLanguageSelect: function(link) {
        var item = link.closest('.popup__select-item');
        var url = item.getAttribute('data-url');
        var localeCount = parseInt(item.getAttribute('data-locales'), 10);
        var languageBase = item.getAttribute('data-base');
        this.highlightSelectedItem(this.langList, '.popup__select-item', item);
        this.getLabel(this.langToggle).textContent = link.textContent.trim();
        this.closeDropdown(this.langToggle, false);
        if (localeCount === 1 && url) {
            this.selectedUrl = url;
            this.selectedLang = languageBase;
            if (this.countrySelect) this.countrySelect.hidden = true;
        } else this.showCountrySelect(languageBase);
    },
    onCountrySelect: function(link) {
        var _link_closest, _link_closest1;
        var href = link.getAttribute('href') || ((_link_closest = link.closest('a')) === null || _link_closest === void 0 ? void 0 : _link_closest.href);
        var lang = link.getAttribute('lang');
        if (href && href !== '#') {
            this.selectedUrl = href;
            this.selectedLang = lang || '';
        }
        this.syncToggleWithLink(this.countryToggle, link);
        this.closeDropdown(this.countryToggle, false);
        var languageBase = (_link_closest1 = link.closest('[data-base]')) === null || _link_closest1 === void 0 ? void 0 : _link_closest1.getAttribute('data-base');
        if (languageBase) {
            var itemsInBase = this.countryList.querySelectorAll('[data-base="'.concat(languageBase, '"]'));
            var selectedItem = link.closest('.popup__select-item');
            this.highlightSelectedItem(itemsInBase, null, selectedItem);
        }
    },
    highlightSelectedItem: function(container, selector, itemToHighlight) {
        var items = selector ? container.querySelectorAll(selector) : container;
        items.forEach(function(item) {
            item.classList.remove('popup__select-item--active');
            item.removeAttribute('aria-selected');
        });
        itemToHighlight === null || itemToHighlight === void 0 ? void 0 : itemToHighlight.classList.add('popup__select-item--active');
        itemToHighlight === null || itemToHighlight === void 0 ? void 0 : itemToHighlight.setAttribute('aria-selected', 'true');
    }
};
window.addEventListener('DOMContentLoaded', function() {
    return $756f64570420134b$var$languagePopup.init();
});

})();
//# sourceMappingURL=script.js.map
